import { useRef } from 'react';
import useOnScreen from '../../hooks/useOnScreen';
import styles from './BookChapter.module.css';

interface ChapterProps {
  title: string;
  children: React.ReactNode;
}

export const BookChapter: React.FC<ChapterProps> = ({ title, children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useOnScreen(ref, '-50px');

  return (
    <section
      ref={ref}
      className={`${styles.chapter} ${styles.fadeIn} ${isVisible ? styles.visible : ''}`}
    >
      <h3 className={styles.chapterTitle}>{title}</h3>
      {children}
    </section>
  );
};